<template>
    <div class="pordermanagement">
        <div v-show="isShowOrderList">
            <div style="height: .3rem"></div>
            <div class="order" v-for="item in getOrserList">
                <ul class="order-title">
                    <li>
                        <b>订单号 ：</b>
                        <span>{{item.ordernumber}}5</span>
                    </li>
                    <li>
                        {{item.zfzt}}
                    </li>
                </ul>
                <ul class="order-center">
                    <li><b>订单日期 ：</b><span>{{item.createtime}}</span></li>
                    <li><b>姓名 ：</b><span>{{item.name}}</span></li>
                    <li><b>套餐类型 ：</b><span>{{item.tc}}</span></li>
                    <li><b>检测状态 ：</b><span>{{item.cpzt}}</span></li>
                </ul>
                <div class="order-footer">
                    <span>
                        ¥{{item.tcprice}}
                    </span>
                    <button @click="buttonCancel"  class="button-cancel" v-if="item.zfzt==='已取消'">再次购买</button>
					<button @click="buttonOrder(item.ordernumber)" class="button-noOrder" v-if="item.zfzt==='未支付'">继续支付</button>
					<button class="button-order" v-if="item.zfzt==='已支付'&&item.cpzt==='已检测'">查看报告</button>
					<button class="button-evaluation" v-if="item.zfzt==='已支付'&&item.cpzt==='未检测'">前往检测</button>
                </div>
            </div>
            
            <div style="height: .7rem"></div>
        </div>
        <myheader  ref="pheader"></myheader>
        <div v-show="isShowNull" class="order-null">
            <img src="../assets/Group.png" />
            <h5>
                暂无订单
            </h5>
        </div>
    </div>
</template>
<script>
   import myheader from '@/phonecomponents/pheader'
	 const components = {
	 	myheader
	 }
    export default {
    	components:components,
        data() {
            return {
                myIScroll: null,
                getordernumber:'',
                getOrserList: {},
                isShowOrderList: false,
                isShowNull: false
            }
        },//data
        created () {
            this.$http.post(urls.urltest + "/personal/getOrderList.json",{
				token: localStorage.getItem('token')
			}).then(function(res){
				console.log(res.body)
				if(res.body.records.length){
					this.isShowOrderList = true;
					this.isShowNull = false;
					console.log(res.body)
					this.getOrserList = res.body.records;
				}else{
					this.isShowOrderList = false;
					this.isShowNull = true;
				}
			})
        },
        methods:{
        	 buttonCancel() {
		    	this.$router.replace('/payment?pID=0');
		    },
		    buttonOrder(oderNumer) {
		    	console.log(oderNumer)
		        window.location.href = urls.urltest +  "/alipay/rewappay?ordernumber="+oderNumer + '&token=' + localStorage.getItem('token');
               
		    }
        },
        mounted() {
            var _this = this;
            setTimeout(function() {
                _this.myIScroll = new IScroll(".pordermanagement", {
                    prevenDefault: true
                })
            })
        },
        updated(){
            this.myIScroll.refresh();
        }
    }
</script>

<style lang="scss">
    @import "../styles/core/reset.scss";
    .pordermanagement{
        width: 100%;
        height: 100%;
        position: relative;
        .order{
            background: #fff;
            font-size: .16rem;
            margin-bottom: .1rem;
            .order-title{
                width: 100%;
                height: .5rem;
                @include flexbox;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px dotted #979797;
                color: #555;                
                li{
                    &:first-child{
                        margin-left: .15rem;
                    }
                    &:last-child{
                        margin-right: .15rem;
                    }
                }
            }
            .order-center{
                padding-left: .15rem;
                color: #555;
                li{
                    padding-top: .15rem;
                }
            }
            .order-footer{
                width: 100%;
                @include flexbox;
                justify-content: space-between;
                padding-top: .3rem;
                span{
                    padding: .1rem 0 0 .15rem;
                    color: red;
                }
                button{
                    width: 1.2rem;
                    height: .3rem;
                    background: #FF912F;
                    color: #fff;
                    border: none;
                    margin: 0 .15rem .15rem 0;
                }
                .button-cancel{
					background: #01BCD4;
				}
				.button-noOrder{
					background: #FF912F;
				}
				.button-order{
					background: #01BCD4;
				}
				.button-evaluation{
					background: #01BCD4;
				}
            }
        }
        .order-null{
            position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			
			img{
				height: 1.05rem;	
			}
			h5{
				font-size: .18rem;
				text-align: center;
                padding-left: .2rem;
                color: #666;
			}
        }
    }
</style>



// WEBPACK FOOTER //
// ordermanagement.vue?7c2d831d